export default __webpack_public_path__ + "static/R3-f03ceff72c4ff23c0a7c432e6f132f6f.png";